var exports = {
  "uK": "GiftPlutoniumModal.module__option___d0lCWG",
  "fS": "GiftPlutoniumModal.module__optionName___d0lCWG",
  "$f": "GiftPlutoniumModal.module__optionPrice___d0lCWG",
  "qS": "GiftPlutoniumModal.module__badge___d0lCWG",
  "N4": "GiftPlutoniumModal.module__note___d0lCWG",
};

module.exports = exports;
